module.exports = __webpack_public_path__ + "static/media/list_bullet.ccd167f3.svg";